// Invoice Types
export const EDIT_INVOCIE = "EDIT_INVOCIE";
export const DELETE_INVOCIE = "DELETE_INVOCIE";
// Cloth Quality Type
export const ADD_CLOTH_QUALITY = "ADD_CLOTH_QUALITY";
export const EDIT_CLOTH_QUALITY = "EDIT_CLOTH_QUALITY";
export const DELETE_CLOTH_QUALITY = "DELETE_CLOTH_QUALITY";
export const GET_CLOTH_QUALITY = "GET_CLOTH_QUALITY";

// yarn quality
export const ADD_YARN_QUALITY = "ADD_YARN_QUALITY";
export const EDIT_YARN_QUALITY = "EDIT_YARN_QUALITY";
export const DELETE_YARN_QUALITY = "DELETE_YARN_QUALITY";
export const GET_YARN_QUALITY = "GET_YARN_QUALITY";

export const PROGRAM_HISTORY = "PROGRAM_HISTORY";

export const ADD_PROGRAM = "ADD_PROGRAM";
export const DELETE_ADD_PROGRAM = "DELETE_ADD_PROGRAM";

// Weave
export const DELETE_WEAVE = "DELETE_WEAVE";
export const EDIT_WEAVE = "EDIT_WEAVE";
export const ADD_WEAVE = "ADD_WEAVE";
export const GET_WEAVE = "GET_WEAVE";
// Selvedge

export const DELETE_SELVEDGE = "DELETE_SELVEDGE";
export const EDIT_SELVEDGE = "EDIT_SELVEDGE";
export const ADD_SELVEDGE = "ADD_SELVEDGE";
export const GET_SELVEDGE = "GET_SELVEDGE";
// Hs Code

export const DELETE_HS_CODE = "DELETE_HS_CODE";
export const EDIT_HS_CODE = "EDIT_HS_CODE";
export const ADD_HS_CODE = "ADD_HS_CODE";
export const GET_HS_CODE = "GET_HS_CODE";


export const DELETE_TAX = "DELETE_TAX";
export const EDIT_TAX = "EDIT_TAX";
export const ADD_TAX = "ADD_TAX";
export const GET_TAX = "GET_TAX";